import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import { rankingFilterAtom } from '../states/rankingFilter.atom';
import { getGoodsAnalytics } from './getGoodsAnalytics';
import type { RankingGoodsCardItem } from '../utils/convertRankingGoodsItemToGoodsData';

export const useLogClickGoods = (params: {
  listId: string | undefined;
  listParams: string | undefined;
}) => {
  const filter = useAtomValue(rankingFilterAtom);

  return useCallback(
    (pressed: RankingGoodsCardItem, index: number) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: getGoodsAnalytics(pressed, index, filter, params, 'CLICK_GOODS'),
      });
      if (isNotNil(pressed.item.ad)) {
        bridge.logAdEvent({ action: AdAction.CLICK, ad: pressed.item.ad });
      }
    },
    [filter, params],
  );
};
